import * as React from 'react';
import { prefixClassName } from 'framework/components/ui/_conf';
import './_styles.scss';

const clx = prefixClassName('stencil-animatedBG');

export const StencilAnimatedGB = () => <div className={clx} />;

export default StencilAnimatedGB;
